export const environment = {
  externalUrls: {
    platform: 'https://admin.asksuite.com',
    control: 'https://control.asksuite.com/api',
    bff: 'https://livechat-bff.asksuite.com',
    bffWebsocket: 'wss://websocket.asksuite.com',
    media: 'https://media.asksuite.com',
    mediaCors: 'https://cors.asksuite.com',
    mediaRendering: 'https://media-rendering.asksuite.com',
    sdk: 'https://0q691dt4cb.execute-api.us-east-1.amazonaws.com',
    pegasus: 'https://asksuite-pegasus-temp.s3.sa-east-1.amazonaws.com',
    pipeline: 'https://pipeline-bff.asksuite.com'
  },
  externalLogs: true,
  hotjar: {
    siteId: 872754,
    version: 6,
  },
  datadog: {
    clientToken: 'pubda84a2bdd94b414483601fc6133bebe6',
    site: 'datadoghq.com',
    service: 'asksuite-livechat',
    forwardErrorsToLogs: true,
    sampleRate: 100,
  },
  mixpanel: {
    projectToken: '029bf7635f670e32ab9806669bd63ac1',
  },
  app: {
    production: true,
    url: 'https://chat.asksuite.com',
  },
  appsUrl: {
    reservationsManager: 'https://new-reservations-app.asksuite.com',
    asksuiteChronos: 'https://chronos.asksuite.com',
    whatsappStartConversation: 'https://whatsapp-god.asksuite.com',
    midas: 'https://midas.asksuite.com',
    tasks: 'https://tasks.asksuite.com',
    intentTrack: 'https://ai-studio.asksuite.com',
    email: 'https://mercury.asksuite.com',
    AsksuiteLiveChatAppReservations:
      'https://reservations-letsbooks-app.asksuite.com',
    GoogleForms:
      'https://feature-ask-new-livechat-register-attendance.d2rledtaj76rku.amplifyapp.com',
    GoogleFormsTab:
      'https://feature-ask-new-livechat-tabulation-aviva.d2vp373p4slilj.amplifyapp.com',
    phone: 'https://phone-livechat.asksuite.com/webphone-app',
  },
  sentryDsn:
    'https://09476f6b4b7f2ca1186cbb3d8b816a35@o455898.ingest.sentry.io/4506751828099072',
  fcmPushNotifications: {
    apiKey: 'AIzaSyDIfaGn7u3_ChZzogPBaPEgW2lRFk1alVA',
    authDomain: 'livechat-b93b1.firebaseapp.com',
    projectId: 'livechat-b93b1',
    storageBucket: 'livechat-b93b1.appspot.com',
    messagingSenderId: '539146582157',
    appId: '1:539146582157:web:c0a6f1c5eac7bafa3e8ac4',
    measurementId: 'G-7358SJGW3V',
    vapidKey:
      'BCDwKCKFOLpb4AEMDr8ELwPkdbKyIEicaeX8x1dQbbI6dGGjfoIZJzR9d06rVFEzf2iiB5WkA8tnLxdY5YzTMS0',
  },
  countryFlagsUrl:
    'https://cors.asksuite.com/https://cdn.asksuite.com/country-codes.json',
  bookingAdminUrl:
    'https://admin.booking.com/hotel/hoteladmin/extranet_ng/manage/booking.html',
  expediaAdminUrl:
    'https://apps.expediapartnercentral.com/lodging/reservations/legacyReservationDetails.html',
  PIPELINE_BFF_URL: 'https://pipeline-bff.asksuite.com',
};
